import {
  Flex,
  IconButton,
  VisuallyHidden,
  Text,
  Grid,
  GridItem,
  Button,
} from '@everlywell/ui-kit';
import { Minus, Plus } from '@phosphor-icons/react';
import React, { useState } from 'react';

export type QuantityControlsProps = {
  quantity: number;
  onDecrement: () => void;
  onIncrement: () => void;
  onRemove: () => void;
};

const QuantityControls = ({
  quantity,
  onDecrement,
  onIncrement,
  onRemove,
}: QuantityControlsProps) => {
  const [isRemoveControlsVisible, setRemoveControlsVisibility] =
    useState(false);

  const handleDecrement = () => {
    if (quantity === 1) {
      setRemoveControlsVisibility(true);
    } else {
      onDecrement();
    }
  };

  const handleCancelRemove = () => {
    setRemoveControlsVisibility(false);
  };

  const handleRemove = () => {
    setRemoveControlsVisibility(false);
    onRemove();
  };

  if (isRemoveControlsVisible) {
    return (
      <Grid spacing={2} columns={2}>
        <GridItem>
          <Button
            variant="secondary"
            colorScheme="redCS"
            onClick={handleRemove}
            width="100%"
            size="sm"
          >
            Remove
          </Button>
        </GridItem>
        <GridItem>
          <Button
            variant="primary"
            onClick={handleCancelRemove}
            width="100%"
            size="sm"
          >
            Cancel
          </Button>
        </GridItem>
      </Grid>
    );
  }

  return (
    <Flex alignItems="center" justifyContent="center">
      <VisuallyHidden
        aria-live="polite"
        role="status"
      >{`Quantity ${quantity}`}</VisuallyHidden>
      <IconButton
        icon={<Minus />}
        variant="primary"
        colorScheme="whiteCS"
        size="sm"
        aria-label="Step down"
        onClick={handleDecrement}
        backgroundColor={'tints.cream'}
        color={'tints.uiGrey'}
      />
      <Text
        as="span"
        size={'md'}
        fontWeight="bold"
        minWidth="30px"
        textAlign="center"
        aria-hidden
      >
        {quantity}
      </Text>
      <IconButton
        icon={<Plus />}
        variant="primary"
        colorScheme="whiteCS"
        size="sm"
        aria-label="Step up"
        onClick={onIncrement}
        backgroundColor={'tints.cream'}
        color={'tints.uiGrey'}
      />
    </Flex>
  );
};

export default QuantityControls;
